import fetch from 'utils/fetch';

export function otaSimList(accountBegin,accountEnd,imsiBegin,imsiEnd,agent,status,psize,currentPage) {
    const data = {
        accountBegin,
        accountEnd,
        imsiBegin,
        imsiEnd,
        status,
        agent,
        psize,
        currentPage
    };
    return fetch({
        url: '/otaSimList',
        method: 'get',
        params : data
    });
}

export function otaSimDetail(account) {
    return fetch({
        url: '/otaSimDetail/'+account,
        method: 'get',
        params : {}
    });
}

export function otaRecharge(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/otaSimRecharge',
        method: 'post',
        data
    });
}







// WEBPACK FOOTER //
// ./src/api/otaSim.js